
<q-dialog
  class="ws-modal"
  v-bind="attrs"
  :value="value"
  square
  v-on="$listeners"
>
  <div class="ws-modal-inner">
    <slot name="header">
      <div
        v-if="cfg.title"
        class="header row"
      >
        <h5>{{ $t(cfg.title) }}</h5>
        <ws-button
          type="secondary-inverse"
          size="small"
          icon="close"
          class="close"
          @click="$emit('input', false)"
        />
      </div>
    </slot>
    <slot></slot>
  </div>
</q-dialog>
